import { render, staticRenderFns } from "./newOrderFooter.vue?vue&type=template&id=4507aa82&scoped=true&"
import script from "./newOrderFooter.vue?vue&type=script&lang=js&"
export * from "./newOrderFooter.vue?vue&type=script&lang=js&"
import style0 from "./newOrderFooter.vue?vue&type=style&index=0&id=4507aa82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4507aa82",
  null
  
)

export default component.exports